import * as React from "react"
import {Box, Typography} from "@mui/material";
import {formatPercentage} from "@ui-seeker/utils";

import PercentageChartNewElementDiffBlock from "./DiffBlock";


export default function PercentageChartNewElementTooltip({ label, width, diff=null, remainingData=[] }) {
	return <Box display="flex" flexDirection="column" justifyContent="center">
		<Typography variant="button" sx={{ textTransform: 'none' }}>
			{label} {formatPercentage(width, { decimals: 1 })}
		</Typography>
		{ (diff ?? null) !== null && !remainingData.length && <Box width={1} textAlign="right" p={0.3}>
			<PercentageChartNewElementDiffBlock diff={diff} />
		</Box> }

		{ !!remainingData.length && <Box width={1} display="flex" flexDirection="column" justifyContent="center">
			{remainingData.map((item, idx) => <Box key={idx} display="flex" justifyContent="center" gap={.5}>
				<Typography variant="caption">
					{item.label} {formatPercentage(item.share, { decimals: 1 })}
				</Typography>
				<PercentageChartNewElementDiffBlock diff={item.diff} />
			</Box>)}
		</Box> }
	</Box>
}